import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'
import FlowReducer from './FlowReducer'
import AppReducer from './AppReducer'

export default combineReducers({
  AuthReducer,
  FlowReducer,
  AppReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/RootReducer.js